<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="24" viewBox="0 0 20 24">
		<g :style="`fill:${active ? 'white' : globalColors.primary};`">
			<path d="M19.979 9.108A9.635 9.635 0 0 0 17.07 2.85c-3.899-3.8-10.243-3.8-14.142 0A9.635 9.635 0 0 0 .02 9.108 9.573 9.573 0 0 0 2.07 15.68l5.718 7.257A2.796 2.796 0 0 0 10 24c.874 0 1.68-.387 2.213-1.063l5.718-7.257a9.574 9.574 0 0 0 2.048-6.572zm-2.811 6.001l-5.718 7.257a1.832 1.832 0 0 1-1.45.696c-.573 0-1.1-.254-1.45-.696l-5.718-7.257A8.669 8.669 0 0 1 3.61 3.513C5.371 1.796 7.686.937 10 .937c2.315 0 4.63.86 6.392 2.577a8.669 8.669 0 0 1 .777 11.595z"/>
			<path d="M15.447 5.746a.485.485 0 0 0-.197.657c.51.945.78 2.016.78 3.097 0 3.6-2.93 6.53-6.53 6.53S2.97 13.1 2.97 9.5 5.9 2.97 9.5 2.97c1.143 0 2.267.3 3.252.866a.485.485 0 1 0 .484-.84A7.498 7.498 0 0 0 9.5 2C5.364 2 2 5.364 2 9.5S5.364 17 9.5 17 17 13.636 17 9.5c0-1.241-.31-2.472-.896-3.557a.485.485 0 0 0-.657-.197zM15.222 4.916A.508.508 0 0 0 15.5 5a.502.502 0 0 0 .354-.854.477.477 0 0 0-.163-.108.505.505 0 0 0-.469.046.478.478 0 0 0-.184.225.506.506 0 0 0-.038.19.5.5 0 0 0 .222.417z"/>
		</g>
	</svg>
</template>
<script>
export default {
	name: 'location-svg',
	props: {
		active: {
			default: false,
			type: Boolean,
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/shared/icons/location.vue